// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompareSharedService } from '@coa/app/shared/select-items-shared/services/compare-shared.service';
import { SelectableFeature, SelectableType } from '@coa/app/shared/select-items-shared/models/selectable-feature';
import { select, Store } from '@ngrx/store';
import { selectIsLoading, selectNames } from '@coa/app/shared/select-items-shared/store/compare-footer.selectors';
import { namesRequested } from '@coa/app/shared/select-items-shared/store/compare-footer.actions';
import { Observable, Subscription } from 'rxjs';
import { CompareNamesResponse } from '@coa/app/shared/select-items-shared/models/compare-stores.response';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';

@Component({
  selector: 'coa-compare-footer',
  templateUrl: './compare-footer.component.html',
  styleUrls: ['./compare-footer.component.scss'],
})
export class CompareFooterComponent implements OnInit, OnDestroy, OnChanges {
  @Input() sidenavCollapsed;
  @Input() selectableType: SelectableType;
  @Input() selections: string[];
  @Input() selectableFeature: SelectableFeature;
  @Input() clientId: string;
  @Input() dateRange: DateRangeFilter;

  isLoading$: Observable<boolean> = this.store$.pipe(select(selectIsLoading));
  feature = SelectableFeature;
  type = SelectableType;
  names: CompareNamesResponse;
  private subscription = new Subscription();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private compareSharedService: CompareSharedService,
    private store$: Store,
  ) {
  }

  ngOnInit(): void {
    const subscription = this.store$.pipe(select(selectNames))
      .subscribe((names) => {
        this.names = names;
      });
    this.subscription.add(subscription);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectableFeature && changes.selectableFeature.currentValue && changes.selectableFeature.previousValue !== changes.selectableFeature.currentValue) {
      this.store$.dispatch(namesRequested({clientId: this.clientId, selectableFeature: this.selectableFeature}));
    }
  }

  remove(id: string): void {
    this.compareSharedService.removeSelection(id, this.selections, this.activatedRoute);
  }

  cancel(): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        selections: undefined,
        selectable: undefined,
        selectableFeature: undefined,
      },
      queryParamsHandling: 'merge',
    });
  }

  compare(): void {
    this.router.navigate(
      [
        '/clients',
        this.clientId,
        'compare',
        this.selectableFeature,
      ], {
        queryParams: {
          selections: this.selections,
          dateRange: this.dateRange,
        },
      });
  }
}
